import React from "react"
import InformationModal from "../modal/InformationModal"
import { Spacer } from "../atoms/Atoms"
import styled from "styled-components"
import { CenteredLayout } from "../atoms/Layouts"
import { seaGrey, pampas } from "css/variables/_colors.scss"
import L10n from "../../../lib/carrot-l10n"
import { Body } from "../atoms/Bodies"
import { Button } from "../atoms/buttons/Button"
import { H2, H3, H5 } from "@carrotfertility/carotene"

const StyledPreFormattedTextBox = styled.div`
  display: inline;
  padding: 4px 8px 4px 8px;
  border: 1px solid ${seaGrey};
  background-color: ${pampas};
  border-radius: 4px;
`

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const MobileFooter = ({ onExit }) => (
  <div className="dn-ns flex flex-auto flex-column items-end">
    <Spacer height={1.5} expand />
    <Button outline onClick={onExit}>
      {l`close`}
    </Button>
    <Spacer height={1.5} />
  </div>
)

const ModalLayout = ({ children }) => (
  <CenteredLayout>
    <div className="mw6 flex flex-column h-100">{children}</div>
  </CenteredLayout>
)

const BaseBankDetailsModal = ({ title, onExit, children, ...props }) => (
  <InformationModal underlayClickExits scrollDisabled={false} onExit={onExit} titleText={title} {...props}>
    <ModalLayout>
      <H2>{title}</H2>
      <Spacer height={1.5} />
      {children}
      <div className="dn db-ns">
        <Spacer height={3} />
      </div>
      <MobileFooter onExit={onExit} />
    </ModalLayout>
  </InformationModal>
)

const BankCodeExample = ({ children }) => (
  <div className="flex items-center">
    <Body>{l`client.ex`}:</Body>
    <Spacer width={0.25} />
    <StyledPreFormattedTextBox>{children}</StyledPreFormattedTextBox>
  </div>
)

const BankCodeDescription = ({ title, body, example }) => (
  <>
    <H3>{title}</H3>
    <Spacer height={0.25} />
    <Body color="black-80">{body}</Body>
    <Spacer height={0.5} />
    <BankCodeExample>
      <H5>{example}</H5>
    </BankCodeExample>
  </>
)

const IbanDetailsModal = ({ onExit }) => (
  <BaseBankDetailsModal onExit={onExit} title={l`bankDetails.ibanOrBsbCode`} dialogId="bank-details-modal-iban">
    <BankCodeDescription
      title={l`bankDetails.iban.title`}
      body={l`bankDetails.iban.body`}
      example="GB29NWBK60161331926819"
    />
    <Spacer height={2} />
    <BankCodeDescription title={l`bankDetails.bsb.title`} body={l`bankDetails.bsb.body`} example="082902" />
  </BaseBankDetailsModal>
)

const AbaRoutingBicOrSwiftDetailsModal = ({ onExit }) => (
  <BaseBankDetailsModal onExit={onExit} title={l`bankDetails.abaRoutingNumberOrSwift`}>
    <BankCodeDescription title={l`bankDetails.aba.title`} body={l`bankDetails.aba.body`} example="129131673" />
    <Spacer height={2} />
    <BankCodeDescription title={l`bankDetails.swift.title`} body={l`bankDetails.swift.body`} example="BUKBGB22" />
  </BaseBankDetailsModal>
)

const SortCodeDetailsModal = ({ onExit }) => (
  <BaseBankDetailsModal onExit={onExit} title={l`bankDetails.sortCode`}>
    <BankCodeDescription title={l`bankDetails.sort.title`} body={l`bankDetails.sort.body`} example="400515" />
  </BaseBankDetailsModal>
)

export { AbaRoutingBicOrSwiftDetailsModal, IbanDetailsModal, SortCodeDetailsModal, ModalLayout }
